<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div>
          道路名称
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.name"></a-input>
        </div>
        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
        <div></div>
      </div>
      <div class="search-r">
      </div>
    </div>
    <a-table :columns="columns" :row-key="(record) => record.id" :data-source="dataSource" class="mt23" size="middle"
      :pagination="pagination" :scroll="{ y: 'auto' }" v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'ranking'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'distance'">
          {{ record.distance || '-' }} km
        </template>
        <template v-if="column.key === 'limitSpeed'">
          {{ record.limitSpeed || '-' }} km/h
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <a @click="detail(record)">详情</a>
            <!-- <a class="ml10"  @click="regulate(record)">管制</a> -->
            <a class="ml10"  @click="fence(record)">围栏</a>
          </span>
        </template>
      </template>
    </a-table>
  
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { getRoadsPageList } from '@/api/roads/roads.js'
import useUserStore from '@/store/modules/user'

const store = useUserStore()

const router = useRouter();

const columns = [
  {
    title: "序号",
    key: "ranking",
    width: 90
  },
  {
    title: "城市",
    key: "cityName",
    dataIndex: "cityName",
    width: 120,
  },
  {
    title: "区域",
    key: "areaName",
    dataIndex: "areaName",
    width: 200,
  },
  {
    title: "道路名称",
    dataIndex: "roadName",
    key: "roadName",
    width: 160,
  },
  {
    title: "道路类型",
    key: "roadLevel",
    dataIndex: "roadLevel",
    width: 160,
  },
  {
    title: "开放路段",
    key: "range",
    dataIndex: "range",
    width: 260,
  },
  {
    title: "里程数",
    key: "distance",
    dataIndex: "distance",
    width: 120,
  },
  {
    title: "限速",
    key: "limitSpeed",
    dataIndex: "limitSpeed",
    width: 100,
  },
  {
    title: "创建时间",
    key: "createTime",
    dataIndex: "createTime",
    width: 180,
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    width: 150,
  },
];

let dataSource = ref([]);
let query = reactive({
  name: "",
});

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize),
  onChange: pageChange,
  showSizeChange: pageSizeChange,
});


function pageChange(page, pageSize) {
  pagination.current = page;
  getData();
}

function pageSizeChange(current, size) {
  pagination.pageSize = size;
  getData();
}

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.name = "";
  pagination.current = 1;
  getData();
};

const getData = async () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query },
  };
  getRoadsPageList(data).then((res) => {
    dataSource.value = res.data.records || res.data.list || [];
    pagination.total = res.data.total || 0;
  });
};

const detail = (record) => {
  router.push({
    path: '/roads/detail',
    query: { id: record.id }
  });
}

const regulate = (record) => {

}

const fence = (record) => {
  router.push({
    path: '/roads/fence',
    query: { roadId: record.id, roadName: record.roadName }
  });
}

onMounted(async () => {
  await getData();
});
</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767e;
}

/deep/.ant-select-selector {
  background-color: #f2f4f7 !important;
  color: #68767e !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
}
</style>